/**
 * Converte HTML rico (cabeçalho/rodapé da empresa) em texto plano para medição e desenho em PDF (jsPDF).
 * Mantém quebras aproximadas de blocos; formatação inline é descartada.
 *
 * Texto **sem tags HTML** (cadastros legados) é devolvido quase intacto, preservando quebras de linha
 * para `splitTextToSize` — compatível com a impressão de Proposta de Preço anterior.
 */
export function htmlToPlainTextForPdf(html) {
  if (html == null) return "";
  let s = String(html);
  if (!s.trim()) return "";
  if (!/<[a-z][\s\S]*>/i.test(s)) return s.trim();

  s = s
    .replace(/<\/(p|div|h[1-6]|blockquote|li|tr|table)>/gi, "\n")
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/(ul|ol|thead|tbody)>/gi, "\n")
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/g, " ");

  if (typeof document !== "undefined") {
    const t = document.createElement("textarea");
    t.innerHTML = s;
    s = t.value;
  } else {
    s = s
      .replace(/&amp;/g, "&")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'");
  }

  return s.replace(/\n{3,}/g, "\n\n").trim();
}
